<crm-single-select
  #singleSelectComponent
  [options]="entities"
  [(selectedItem)]="_selectedEntity"
  (selectedItemChange)="onSelect($event)"
  [class]="'w-full ' + class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="'w-full ' + styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="50"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [loading]="selectionLoading"
  filterBy="name,inn">
  <ng-template
    #itemTemplate
    let-contragent="item">
    <ng-container *ngIf="toContragent(contragent) as contragent">
      <div>
        <div>
          <span [innerHTML]="highlightMatchText(contragent.name) | safeHtml"></span>
        </div>
        <div
          *ngIf="contragent.inn"
          class="frm-color-green">
          ИНН:
          <span [innerHTML]="highlightMatchText(contragent.inn) | safeHtml"></span>
        </div>
        <div
          *ngIf="contragent.kpp"
          class="text-gray-500">
          КПП: {{ contragent.kpp }}
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
